import { VenueRequestFile } from '@go-shared/types/groupBooking';
import React, { Fragment, useEffect, useState } from 'react';
import { UploadButton } from '../UIkit/forms/UploadButton/UploadButton';
import BubbleButton from './BubbleButton';
import BubbleFormGroup from './BubbleFormGroup';
import BubbleInput from './BubbleInput';

import './BubbleFileM.scss';

interface BubbleFileMProps {
  label?: string;
  files: VenueRequestFile[];
  disabled?: boolean;
  hideNoneLabel?: boolean;
  className?: string;
  onUpdateFile?: (evt: VenueRequestFile) => void;
  onUploadFile?: (file: File) => void;
  onDeleteFile?: (file: VenueRequestFile) => void;
}

export default function BubbleFileM(props: BubbleFileMProps) {
  const [newName, setNewName] = useState('');
  const [editingFile, setEditingFile] = useState<VenueRequestFile | undefined>(undefined);

  useEffect(() => {
    setNewName(editingFile?.name ?? '');
  }, [editingFile]);

  function handleOnUpdateClick(file: VenueRequestFile) {
    if (!props.onUpdateFile) return;

    props.onUpdateFile({ ...file, name: newName });
    setEditingFile(undefined);
  }

  return (
    <BubbleFormGroup label={props.label || 'Files'} className={props.className}>
      <div className="bubble-file-m px-5 pb-3 pt-2 rounded border bg-white">
        {!props.hideNoneLabel && props.files.length < 1 && (
          <div className="text-smoke italic pt-1">None</div>
        )}
        {props.files.map((rf, i) => (
          <Fragment key={i}>
            {rf._id === editingFile?._id ? (
              <>
                <div className="w-full flex items-center">
                  <BubbleInput
                    className="flex-grow mr-3"
                    type="text"
                    autoFocus
                    block
                    value={newName}
                    onValue={setNewName}
                  />
                  <BubbleButton
                    variant="lime"
                    inverse
                    className="p-2-i"
                    onClick={() => handleOnUpdateClick(rf)}
                    icon="check"
                  />
                  <BubbleButton
                    variant="slate"
                    inverse
                    className="p-2-i"
                    onClick={() => setEditingFile(undefined)}
                    icon="rotate-left"
                  />
                  <span className="-mr-3"></span>
                </div>
              </>
            ) : (
              <div className="w-full flex items-center">
                <BubbleButton
                  variant="navy"
                  inverse
                  block
                  size="small"
                  className="p-0-i underline text-left flex-grow mr-3"
                  linkProps={{ to: rf.location, target: '_blank' }}
                >
                  {rf.name}
                </BubbleButton>
                {props.onUpdateFile && (
                  <BubbleButton
                    variant="navy"
                    inverse
                    className="p-2-i"
                    onClick={() => setEditingFile(rf)}
                    icon="edit"
                  />
                )}
                {props.onDeleteFile && (
                  <BubbleButton
                    variant="crimson"
                    inverse
                    className="p-2-i"
                    onClick={() => props.onDeleteFile && props.onDeleteFile(rf)}
                    icon="trash-alt"
                  />
                )}
                <span className="-mr-3"></span>
              </div>
            )}
          </Fragment>
        ))}
        <div className="flex items-center mt-3">
          <UploadButton
            singleUpload
            onFilesChange={f => props.onUploadFile && props.onUploadFile(f[0])}
            // Render props FTW
            render={upload => {
              return (
                <BubbleButton
                  variant="navy"
                  onClick={upload}
                  disabled={props.disabled}
                  icon="file-upload"
                >
                  Choose File
                </BubbleButton>
              );
            }}
          />
          {props.onUpdateFile && (
            <div className="text-xs italic text-smoke ml-3">
              File name changes will only take effect when form is submitted
            </div>
          )}
        </div>
      </div>
    </BubbleFormGroup>
  );
}
